import toggleDarkModeTheme from 'owa-dark-mode-option/lib/actions/toggleDarkModeTheme';
import { mutator } from 'satcheljs';
import { getStore } from 'owa-mail-compose-store';

function toggleDarkModeOnViewStates(newDarkModeState: boolean) {
    getStore().viewStates.forEach(viewState => {
        viewState.isDarkMode = newDarkModeState;
    });
}

mutator(toggleDarkModeTheme, msg => toggleDarkModeOnViewStates(msg.isDarkModeEnabled));
